import React from "react";
import {
  storyblokEditable,
  StoryblokComponent
} from "@storyblok/react";

import LandingPageHero from "@components/organisms/LandingPageHero";
import RichText from "@components/atoms/RichText";
import { tryToReplaceDomain } from "@utils/tryToReplaceDomain";
import { LandingPageHeroProps } from "@components/organisms/LandingPageHero/types";
import { getImage } from "@utils/getImage";
import Breadcrumbs from "@components/molecules/Breadcrumbs";

import { LandingPageHeroStoryblokProps } from "./types";

const LandingPageHeroStoryblok: React.FC<
  LandingPageHeroStoryblokProps
> = ({ blok }) => {
  const {
    _uid: key,
    heading: title,
    desc: description,
    icons,
    form,
    color,
    backgroundImage,
    firstText,
    secondText,
    breadcrumbs
  } = blok;

  const item: LandingPageHeroProps = {
    title: <RichText content={title[0]?.text} />,
    description: description?.[0].text?.content[0].content?.length ? (
      <RichText content={description?.[0].text} />
    ) : undefined,
    icons:
      icons?.map(({ filename }) => tryToReplaceDomain(filename)) ||
      [],
    $color: color?.color,
    backgroundImage: getImage(backgroundImage),
    firstText: firstText?.[0].text?.content[0].content?.length ? (
      <RichText content={firstText?.[0].text} />
    ) : undefined,
    secondText: secondText?.[0].text?.content[0].content?.length ? (
      <RichText content={secondText?.[0].text} />
    ) : undefined,
    breadcrumbs: breadcrumbs?.length ? (
      <Breadcrumbs {...{ breadcrumbs }} />
    ) : undefined
  };

  return (
    <LandingPageHero
      {...{ key, ...item, ...storyblokEditable(blok) }}
    >
      <StoryblokComponent blok={form[0]} />
    </LandingPageHero>
  );
};

export default LandingPageHeroStoryblok;
